$(document).ready(function () {
    $('.carousel.slide').on('slide.bs.carousel', function (ev) {
        awakeIframes(ev.relatedTarget);
    });

    awakeIframes($('.carousel.slide .item.active'));
});

function awakeIframes(slide) {
    try {
        let $target = $(slide);

        $('iframe.lazy', $target).trigger('appear');
        $('iframe.lazy', $target.next()).trigger('appear');
    } catch (e) {
        console.warn('Could not awake iframes');
    }
}
